(function() {
  const IMAGES = window.SLT_MENU_IMAGES || {};
  console.log('SLT menu images:', IMAGES);

  function init() {
    const wrappers = document.querySelectorAll('.header-mega--menu');
    let panel = null;
    wrappers.forEach(w => {
      const t = w.querySelector('.summary span')?.textContent?.trim();
      if (t === 'Produkte') panel = w.querySelector('[id^="HeaderMenu-MenuList-"]');
    });
    if (!panel) return;

    panel.classList.add('slt-hover-menu');
    const aside = document.createElement('div');
    aside.className = 'slt-menu-hover-image';
    const img = document.createElement('img');
    img.alt = '';
    aside.appendChild(img);
    panel.appendChild(aside);

    const firstUrl = Object.values(IMAGES)[0];
    if (firstUrl) img.src = firstUrl;

    panel.querySelectorAll('.col-3 .wbmenuinner > a').forEach(a => {
      a.addEventListener('mouseenter', () => {
        const url = IMAGES[a.textContent.trim()];
        if (url) img.src = url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();